// extracted by mini-css-extract-plugin
export default {"priceContainer":"dda-z","discountedPrice":"eda-z","originalPrice":"fda-z","productPrice":"gda-z"};